/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_Will_UpdateInputs */

const cs_import_stat_will_update = /** @type {(inputs: Import_Stat_Will_UpdateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualizuje se: ${i?.count}`)
};

const en_import_stat_will_update = /** @type {(inputs: Import_Stat_Will_UpdateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Will update: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Will update: {count}" |
*
* @param {Import_Stat_Will_UpdateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_will_update = /** @type {((inputs: Import_Stat_Will_UpdateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_Will_UpdateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_will_update(inputs)
	return cs_import_stat_will_update(inputs)
});